import React from "react";
import Employees  from "../modules/Employees/Employees";
export default function EmployeesPage() {
  return <Employees />;
}
